import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { loadConfig } from './lib/config.js';
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('#root is missing from index.html');

// Configuration BEFORE the first render. The client id decides whether sign-in
// can work at all, and a component that had to cope with "not loaded yet"
// would be one more state to get wrong. See lib/config.ts.
await loadConfig();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
